export const unitDetails = {
  'Unit not found': 'Unidade não encontrada!',
  'The page for the unit you searched for was not found Try searching for other units by clicking the link below':
    'A página da unidade pesquisada não foi encontrada. Tente pesquisar outras unidades clicando no link abaixo.',
  'Search units': 'Pesquisar unidades',

  'Vialaser - Clinic {{unit}}': 'Vialaser - Clínica {{unit}}',
  'At this location, we serve clients in the <2>{{city}} - {{state}}</2> region, offering a welcoming environment and personalized service Schedule your consultation and discover the benefits of permanent laser hair removal':
    'Nesta unidade, atendemos clientes na região de <2>{{city}} - {{state}}</2>, oferecendo um ambiente acolhedor e um atendimento personalizado. Agende sua avaliação e conheça os benefícios da depilação a laser definitiva.',

  Address: 'Endereço',
  'See in the map': 'Ver no mapa',

  Contact: 'Contato',
  'Message in WhatsApp': 'Chamar no WhatsApp',

  'Service Hours': 'Horários',

  Services: 'Serviços',
  'Laser hair removal for Women': 'Depilação a Laser',
  'Laser hair removal for Man': 'Depilação a Laser Masculina',

  'Vialaser advantages': 'Depilação a Laser',

  'Advanced technology': 'Tecnologia avançada',
  "The world's first square tip, covering more area in less session time and without misses":
    'A primeira ponteira quadrada do mundo, mais área coberta em menos tempo de sessão e sem falhas.',

  Painless: 'Menos dor',
  'Laser with dual cooling ensures the most painless application on the market and a cool, refreshing feeling on the skin during treatment':
    'Laser com duplo resfriamento garante a aplicação mais indolor do mercado e uma pele geladinha durante o tratamento.',

  'For all kinds of skin colors': 'Para todos os tons de peles',
  'We combine two laser technologies: Alexandrite and Nd:YAG This guarantees excellent results on all skin tones':
    'Combinamos duas tecnologias a laser: Alexandrite e Nd:YAG. Que garante ótimos resultado em todos os tons de peles',

  Loading: 'Carregando...',
  'I need to talk to Vialaser customer service':
    'Preciso de atendimento da Vialaser',
};
